import React from 'react';
import './About.css';

const About = () => {
  return (

    <section className="about section" id="about">
      <div className="container">
        <div className="about-content">
          <div className="about-container">

            <section className="about-text">
              <h2 className="section-title">About the Chhatrapati Shahu Ji Maharaj University</h2>
              <p>
                Chhatrapati Shahu Ji Maharaj University Kanpur, a premier landmark of
                higher education in Uttar Pradesh, is named after the great social
                reformer Chhatrapati Shahu Maharaj, also known as Rajarshi Shahu. The
                university stands as a beacon of excellence in higher education, proudly
                holding an NAAC A++ accreditation and classified under the UGC
                Grade-I category. Under the dynamic leadership of our Vice Chancellor,
                Prof. Vinay Kumar Pathak, who also serves as the President of the
                Association of Indian Universities, the institution has fostered a vibrant
                academic environment that encourages innovation and research. With
                a strong emphasis on quality education and holistic development, the
                university offers a diverse range of programs and has established itself
                as a hub for intellectual growth and community engagement. Its
                commitment to excellence is reflected not only in its stellar
                accreditation but also in the achievements of its faculty and students,
                making it a sought-after destination for aspiring scholars.

              </p>

              <p>
                The University currently offers various PhD, Postgraduate and
                Undergraduate programs. It has a well-equipped Seminar Hall,
                Auditorium and Senate Hall wherein regular seminars, workshops,
                cultural activities and interactive sessions are conducted. The
                University’s Ganesh Shankar Vidyarthi Central Library is one of the best
                in India.
              </p>
            </section>
            <section className="about-text">
              <h2 className="section-title">About Atal Bihari Vajpayee School Of Legal Studies </h2>
              <p>
                Atal Bihari Vajpayee School of Legal Studies, Kanpur, stands for
                excellence in legal education and was established in 2017 under the
                illustrious banner of Chhatrapati Shahu Ji Maharaj University, Kanpur.
                The premier law school is set up with a mission to pioneer legal
                education reforms and to anchor the transformation of the Indian legal
                system through research and policy interventions.
              </p>
              <p>
                It offers 5-year integrated Undergraduate Programmes like BA. LL. B.
                (Honours), B.B.A. LL.B. (Honours), Three-Year LL.B. (Honours) and One year
                & Two-year LL.M. programme with specializations in Business Law,
                Criminal Law and Constitutional Law. The department also offers Ph.D. in
                Law.
              </p>
              <p>
                The curriculum and pedagogy are designed around the latest quality
                initiatives in legal education in India. These are imparted through
                multitalented, qualified, competent and enthusiastic faculty. Those
                efforts are reciprocated by the participation of all the stakeholders,
                including the members of the Bar and Bench, the corporate sector and
                national experts.
              </p>
              <p>
                Atal Bihari Vajpayee School of Legal Studies, Kanpur aims at creating
                world-class professionals, committed academicians and law reformers,
                training justice dispensers, invigorating community crusaders and
                creating a strong watershed of new and upcoming expertise in law.
              </p>


            </section>
            <section className="about-text">
              <h2 className="section-title">About the Conference</h2>
              <p>The International Conference on Cybersecurity Law and Governance: Building Global Resilience seeks to create a dynamic platform for dialogue between legal scholars, technology experts, policymakers, industry leaders, and international organizations to address the multifaceted challenges of cybersecurity in the digital era.</p>
              <p>As societies become increasingly interconnected, the risks posed by cyber threats, data breaches, misinformation, and the misuse of emerging technologies have grown exponentially. These developments demand not only stronger technological safeguards but also adaptive legal frameworks, ethical accountability, and cooperative global governance.</p>

              <p>This conference will explore a broad spectrum of contemporary issues, including cross-border cybercrime and jurisdictional barriers, privacy and data protection laws, corporate responsibility in cybersecurity, AI regulation, digital forensics, and the evolving role of international collaboration in cyber governance. By fostering interdisciplinary discussions, the event aims to bridge the gap between policy and practice, helping nations and institutions build sustainable cybersecurity ecosystems.</p>

              <p>Selected papers from the conference will be considered for publication in a special issue of an internationally reputed journal, providing a global platform for impactful scholarship.</p>

              <p>The conference ultimately aspires to strengthen the collective understanding of how law and governance can safeguard digital rights, promote accountability, and build a resilient global cyber order.</p>


            </section>

          </div>


        </div>
        <div class="ojective-section">
          <section className="about-text">
            <h2 className="objective-title">Objectives of the Conference</h2>
            <p>
              The International Conference on Cybersecurity Law and
              Governance: Building Global Resilience is designed to
              advance critical dialogue and collaboration at the
              intersection of law, technology, and policy.
              The primary objective of the conference is to examine
              how evolving legal frameworks and governance mechanisms
              can effectively respond to the growing complexity of
              cybersecurity threats in an interconnected world. It
              seeks to promote interdisciplinary engagement among legal
              scholars, technologists, policymakers, and industry leaders
              to identify sustainable solutions that uphold privacy,
              accountability, and digital rights.</p>

            <p>The conference also aims to assess global approaches
              to cybersecurity regulation, explore mechanisms for cross-border
              cooperation, and evaluate the legal and ethical dimensions of
              emerging technologies such as artificial intelligence, blockchain,
              and digital currencies. By facilitating discussions on best practices,
              enforcement challenges, and capacity building, the event aspires
              to contribute to the development of resilient governance structures
              capable of safeguarding individuals and institutions against digital
              vulnerabilities. Ultimately, the conference endeavors to strengthen
              international cooperation, encourage evidence-based policy formulation,
              and build a forward-looking vision for global cybersecurity resilience.

            </p>
          </section>
        </div>
      </div>

    </section>


  );
};

export default About;